module.exports = __webpack_public_path__ + "static/media/yi_ting_tsai.f0bcbf14.jpg";